import type { SVGProps } from 'react';

const Svg2022UadSubclipAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M5 18H4c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1m15 0h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1m-4.33-9.69-5.41-3.12c-.92-.53-2.06.13-2.06 1.19v6.24c0 1.06 1.15 1.72 2.06 1.19l5.41-3.12c.92-.53.92-1.85 0-2.38M14 17c-.55 0-1 .45-1 1H9c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1h4c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1m9-14h-2V1c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V5h2c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default Svg2022UadSubclipAdd;
